import { render } from "./PdfAnlagenschemaTemplate.vue?vue&type=template&id=1f5997d7&scoped=true&ts=true"
import script from "./PdfAnlagenschemaTemplate.vue?vue&type=script&lang=ts"
export * from "./PdfAnlagenschemaTemplate.vue?vue&type=script&lang=ts"

import "./PdfAnlagenschemaTemplate.vue?vue&type=style&index=0&id=1f5997d7&scoped=true&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5997d7"]])

export default __exports__